export default __webpack_public_path__ + "static/jemin-74f1cc0f2a1b64d0867a4c83fa3a18dd.png";